import AccountContainer from './AccountContainer';

export default AccountContainer;